export default __webpack_public_path__ + "static/media/avatar_163.d51594d6.png";